import classNames from 'classnames';
import styles from "./styles/Popup.module.scss";

export function Arrow(props: {
    position: "top" | "bottom" | "left" | "right",
    className?: string,
}) {
    const arrowClassName = classNames({
        [styles.arrow]: true,
        [styles.bottom]: props.position === "bottom",
        [styles.top]: props.position === "top",
        [styles.left]: props.position === "left",
        [styles.right]: props.position === "right",
        [props.className || ""]: props.className,
    })

    return <div className={arrowClassName}/>
}